<template>
  <v-row class="main-container">
    <dialog-manage-quotation
      v-if="dialogManageQuotation"
      :dialog="dialogManageQuotation"
      v-model="selectedQuotation"
      v-on:dialog-close="onDialogManageQuotationClose"
    ></dialog-manage-quotation>

    <dialog-quotation-overview
      :quotation="selectedQuotationOverview"
      :dialog="dialogQuotationOverview"
      v-on:dialog-close="onDialogClose"
    ></dialog-quotation-overview>

    <dialog-manage-invoice
      :dialog="dialogManageInvoice"
      v-model="selectedInvoice"
      v-on:dialog-close="onDialogClose"
    ></dialog-manage-invoice>

    <!-- Dialog for managing shipment files upload -->
    <dialog-file-cabinet
      v-model="selectedShipmentId"
      :company_id="selectedCompanyId"
      :dialog="dialogFileCabinet"
      :isBooking="false"
      v-on:dialog-close="onDialogClose"
    ></dialog-file-cabinet>
    <!-- End of dialogs -->

    <!-- warning dialog -->
    <v-dialog v-model="dialogOnUpdateStatus" max-width="530">
      <v-card v-if="selectedInvoice != null" color="white" tile flat>
        <v-card-title dark class="dialog-header-title">{{
          updateStatusTitle
        }}</v-card-title>
        <v-card-text class="mt-3">
          <v-alert tile outlined type="info" border="left" dense>
            <span>
              {{ updateStatusMsg }}
              <strong>{{ selectedInvoice.invoice_id }}?</strong>
            </span>
            <br />
            <br />
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              class="mx-7 font-weight-bold"
              color="primary"
              depressed
              tile
              @click="updateInvoiceStatus"
              >{{ updateStatusBtnName }}</v-btn
            >
            <v-btn
              class="mx-7 font-weight-bold"
              color="error"
              tile
              depressed
              dark
              @click="dialogOnUpdateStatus = false"
              >CLOSE</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End warning dialog -->

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>
    <!-- <v-alert v-model="alert" :type="alertType" dismissible>{{alertMessage}}</v-alert> -->

    <v-row no-gutters class="pa-2">
      <v-col>
        <v-subheader class="headline pl-0 ml-0" style="color: #1976d2"
          >Invoices</v-subheader
        >
      </v-col>

      <v-col class="d-flex justify-content-end pt-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="initializeInvoiceList(false)">
              <v-icon size="30" color="primary">mdi-refresh</v-icon>
            </v-btn>
          </template>
          Refresh invoice list
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="3">
        <af-pagination
          v-model="pagination"
          v-on:next="onNextPage"
          v-on:prev="onPrevPage"
          v-on:rows-per-page-change="onitemsPerPageChange"
        ></af-pagination>
      </v-col>

      <v-col cols="12" sm="12" md="6" class="pt-1">
        <!-- <div style="display: inline">Show: &nbsp;&nbsp;&nbsp;</div> -->
        <v-btn-toggle
          class="v-btn-toggle-new-quotation"
          mandatory
          dense
          v-model="filterInvoiceStatus"
        >
          <v-btn class="px-0" text :value="0">All</v-btn>
          <v-btn class="px-0" v-if="$root.is_admin" text :value="1"
            >Draft</v-btn
          >
          <v-btn class="px-2" v-if="$root.is_admin" text :value="2"
            >Awaiting Approval</v-btn
          >
          <v-btn class="px-2" text :value="3">Awaiting Payment</v-btn>
          <v-btn class="px-0" text :value="4">Paid</v-btn>
          <v-btn class="px-2" v-if="$root.is_admin" text :value="5"
            >Trashed</v-btn
          >
        </v-btn-toggle>
      </v-col>

      <v-col cols="12" sm="12" md="3" class="d-flex justify-end pr-2">
        <v-autocomplete
          v-if="$root.is_admin"
          class="form-control rounded-0"
          :items="sortedCompanies"
          return-object
          v-model="selectedCompany"
          placeholder="Select Company Name"
          clearable
          item-text="name"
          solo
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <v-divider></v-divider>
    </v-row>

    <v-row no-gutters class="pa-2">
      <v-col cols="12" v-if="!empty_invoice_list">
        <template v-for="(item, i) in invoicesTableView">
          <v-row :key="i" no-gutters>
            <v-col>
              <v-card
                :color="setBackgroundColor(item).bg"
                tile
                class="elevation-3"
              >
                <v-card-text class="py-0 pr-0 pl-2">
                  <v-row no-gutters>
                    <v-col cols="10">
                      <v-row no-gutters>
                        <v-col
                          cols="4"
                          class="pt-0 d-flex justify-content-start"
                        >
                          <v-row>
                            <span
                              class="font-weight-bold body black--text mr-2"
                            >
                              <v-icon size="20" class="pb-1" color="primary"
                                >mdi-receipt</v-icon
                              >
                              {{ item.invoice_id }}
                            </span>

                            <v-chip
                              x-small
                              class="mt-1 pa-1 mx-2 font-weight-bold caption"
                              label
                              outlined
                              >{{ item.quotation_id }}</v-chip
                            >

                            <v-chip
                              x-small
                              class="
                                mt-1
                                pa-1
                                mx-2
                                font-weight-bold
                                caption
                                text-lowercase
                              "
                              label
                              outlined
                              >{{ item.invoice_type }}</v-chip
                            >

                            <!-- <v-chip
                              x-small
                              class="mt-1 pa-1 mx-2 font-weight-bold caption"
                              label
                              outlined
                              >{{ item.currency }}</v-chip
                            > -->
                          </v-row>
                        </v-col>

                        <v-col cols="8" class="pt-1">
                          <v-row no-gutters>
                            <span class="caption black--text">
                              <span class="font-weight-bold">Issued Date:</span>
                              {{ item.issued_date }}
                            </span>

                            <span class="mx-2">|</span>

                            <span
                              v-if="item.status == CONSTANT.STATUS.INVOICE.PAID"
                              class="caption black--text"
                            >
                              <span class="font-weight-bold">Paid Date:</span>
                              {{ item.paid_date }}
                            </span>
                            <span v-else class="caption black--text">
                              <span class="font-weight-bold">Due Date:</span>
                              {{ item.due_date }}
                            </span>

                            <span
                              v-if="item.overdue"
                              class="caption error--text"
                            >
                              <span class="mx-2 black--text">|</span>
                              <span class="font-weight-bold">Overdue By:</span>
                              {{ `${item.overdue_by} days` }}
                            </span>

                            <span class="mx-2">|</span>

                            <span class="caption black--text">
                              <span class="font-weight-bold">Updated:</span>
                              {{ item.updated }}
                            </span>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col
                      v-if="$root.is_admin && !item.authorised && !item.trash"
                    >
                      <v-row justify="end">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              x-small
                              tile
                              outlined
                              color="primary"
                              class="
                                font-weight-bold
                                mr-2
                                px-1
                                mt-1
                                text-uppercase
                              "
                              @click="
                                onUpdateInvoiceStatus(
                                  item,
                                  CONSTANT.STATUS.INVOICE.SUBMITTED
                                )
                              "
                              v-show="
                                item.status == CONSTANT.STATUS.INVOICE.DRAFT
                              "
                              >SUBMIT</v-btn
                            >
                          </template>
                          Submit a draft invoice
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              x-small
                              tile
                              outlined
                              color="green darken-3"
                              class="
                                font-weight-bold
                                mr-2
                                px-1
                                mt-1
                                text-uppercase
                              "
                              @click="
                                onUpdateInvoiceStatus(
                                  item,
                                  CONSTANT.STATUS.INVOICE.AUTHORISED
                                )
                              "
                              v-if="
                                [
                                  CONSTANT.STATUS.INVOICE.DRAFT,
                                  CONSTANT.STATUS.INVOICE.SUBMITTED,
                                ].includes(item.status)
                              "
                              >APPROVE</v-btn
                            >
                          </template>
                          Approve a draft / submitted invoice
                        </v-tooltip>
                      </v-row>
                    </v-col>

                    <v-col v-else class="d-flex justify-end">
                      <v-chip
                        x-small
                        class="px-1 font-weight-bold caption"
                        label
                        :color="getInvoiceStatus(item).color"
                        text-color="white"
                        >{{ getInvoiceStatus(item).title }}</v-chip
                      >
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-row class="pt-3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-show="!item.trash"
                              v-on="on"
                              small
                              text
                              color="primary"
                              class="font-weight-bold pl-1"
                              @click="downloadInvoice(item)"
                            >
                              <v-icon size="20" left class="mr-1"
                                >mdi-download</v-icon
                              >Download
                            </v-btn>
                          </template>
                          Download Invoice
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-show="!item.trash"
                              v-on="on"
                              small
                              text
                              color="primary"
                              class="font-weight-bold pl-1"
                              @click="onQuotationOverview(item)"
                            >
                              <v-icon size="20" left class="mr-1"
                                >mdi-open-in-new</v-icon
                              >Quotation
                            </v-btn>
                          </template>
                          View quotation details
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-show="!item.trash"
                              v-on="on"
                              small
                              text
                              color="primary"
                              class="font-weight-bold pl-1"
                              @click="onOpenShipmentFileCabinet(item)"
                            >
                              <v-icon size="20">mdi-file-outline</v-icon>Files
                            </v-btn>
                          </template>
                          <span>Shipment files</span>
                        </v-tooltip>

                        <template v-if="$root.is_admin">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                v-show="
                                  item.status != CONSTANT.STATUS.INVOICE.PAID &&
                                  !item.trash
                                "
                                small
                                text
                                color="#0D2C54"
                                class="font-weight-bold"
                                @click="onManageInvoice(item)"
                              >
                                <v-icon size="20" left class="mr-1"
                                  >mdi-pencil</v-icon
                                >Edit
                              </v-btn>
                            </template>
                            Edit invoice detail
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                v-show="
                                  item.status ==
                                  CONSTANT.STATUS.INVOICE.AUTHORISED
                                "
                                small
                                text
                                color="error"
                                class="font-weight-bold"
                                @click="
                                  onUpdateInvoiceStatus(
                                    item,
                                    CONSTANT.STATUS.INVOICE.VOIDED
                                  )
                                "
                              >
                                <v-icon size="20" left class="mr-1"
                                  >mdi-cancel</v-icon
                                >Void
                              </v-btn>
                            </template>
                            Void authorised / approved invoice
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                v-show="
                                  item.status ==
                                    CONSTANT.STATUS.INVOICE.DRAFT ||
                                  item.status ==
                                    CONSTANT.STATUS.INVOICE.SUBMITTED
                                "
                                small
                                text
                                color="error"
                                class="font-weight-bold"
                                @click="
                                  onUpdateInvoiceStatus(
                                    item,
                                    CONSTANT.STATUS.INVOICE.DELETED
                                  )
                                "
                              >
                                <v-icon size="20" left class="mr-1"
                                  >mdi-delete</v-icon
                                >Delete
                              </v-btn>
                            </template>
                            Delete draft / submitted invoice
                          </v-tooltip>

                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                small
                                text
                                color="#0D2C54"
                                class="font-weight-bold"
                                @click="onReSyncWithXero(item)"
                              >
                                <v-icon size="20" left class="mr-1"
                                  >mdi-sync</v-icon
                                >Xero Sync
                              </v-btn>
                            </template>
                            Re-Sync Invoice with Xero
                          </v-tooltip>
                        </template>
                      </v-row>
                    </v-col>

                    <v-col cols="2">
                      <v-row class="pt-4" v-if="$root.is_admin">
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <span
                              v-on="on"
                              class="
                                font-weight-medium
                                caption
                                text-uppercase
                                black--text
                                mr-4
                              "
                              >{{ item.company.short_name }}</span
                            >
                          </template>
                          {{ item.company.name }}
                        </v-tooltip>
                      </v-row>
                    </v-col>

                    <v-col cols="1" v-if="$root.is_admin && item.invoice_sent">
                      <v-row class="pt-4">
                        <span
                          class="
                            caption
                            green--text
                            text--darken-3
                            font-weight-bold
                          "
                          >Invoice sent</span
                        >
                      </v-row>
                    </v-col>

                    <v-col v-show="item.status != CONSTANT.STATUS.INVOICE.PAID">
                      <v-row justify="end" class="pr-2">
                        <span class="caption font-weight-bold">Amount Due</span>
                      </v-row>

                      <v-row justify="end" class="pr-2">
                        <span class="font-weight-bold black--text"
                          >{{ item.currency }}
                          {{
                            item.amount_due != null
                              ? item.amount_due.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "N/A"
                          }}</span
                        >
                      </v-row>
                    </v-col>

                    <v-col class="pr-2">
                      <v-row justify="end">
                        <span class="caption font-weight-bold"
                          >Amount Paid</span
                        >
                      </v-row>

                      <v-row justify="end">
                        <span class="font-weight-bold black--text"
                          >{{ item.currency }}
                          {{
                            item.amount_paid != null
                              ? item.amount_paid.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "N/A"
                          }}</span
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-divider :key="`${i}divider`"></v-divider>
        </template>
      </v-col>

      <v-col v-else class="mt-10 pa-10">
        <v-alert tile dense prominent type="error">
          <v-row align="center">
            <v-col v-if="selectedCompany != null" class="grow">
              <strong>{{ selectedCompany.name }}</strong> does not have any
              Invoice at the moment
            </v-col>
            <v-col v-else class="grow">Invoice list is empty</v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../const"
import DialogManageQuotation from "@/components/admin/dialogs/DialogManageQuotation"
import DialogQuotationOverview from "@/components/user/DialogQuotationOverview"
import DialogManageInvoice from "@/components/admin/dialogs/DialogManageInvoice"
import AFPagination from "@/components/shared/AFPagination"

export default {
  components: {
    DialogManageQuotation,
    DialogQuotationOverview,
    DialogManageInvoice,
    "af-pagination": AFPagination,
  },

  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",

      dialogManageQuotation: false,
      dialogQuotationOverview: false,
      dialogManageInvoice: false,
      dialogFileCabinet: false,

      dialogOnUpdateStatus: false,
      selectedInvoiceStatus: null,
      updateStatusTitle: null,
      updateStatusMsg: null,
      updateStatusBtnName: null,

      selectedInvoice: null,
      selectedInvoiceSync: {},

      selectedShipmentId: null,
      selectedCompanyId: null,

      selectedQuotation: null,
      selectedQuotationOverview: null,

      filterInvoiceStatus: 3,
      selectedCompany: null,
      companies: [],

      pagination: {
        sortBy: ["countid"],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 20,
        totalItems: 0,
      },

      invoices: [],
      invoicesTableView: [],
      empty_invoice_list: false,
    }
  },

  async created() {
    this.$root.fullScreenView = false
    this.$root.blockUImsg = "Loading invoices"
    this.$root.blockUIshow = true
    // verify user token
    await this.$root.verify_user_token()

    this.initializeInvoiceList(false)
    this.loadCompanies()
  },

  mounted() {},

  watch: {
    selectedCompany: function () {
      this.initializeInvoiceList(false)
    },
    filterInvoiceStatus: function () {
      this.initializeInvoiceList(false)
    },
  },

  methods: {
    // Pagination methods
    /**
     * On Next Page Selected
     */
    onNextPage() {
      let isLastPageLoaded =
        this.pagination.itemsPerPage * (this.pagination.page - 1) ==
        this.invoices.length

      if (isLastPageLoaded) {
        this.initializeInvoiceList(true)
      } else {
        this.refreshInvoicesViewList()
      }
    },

    /**
     * On Previous Page Selected
     */
    onPrevPage() {
      this.refreshInvoicesViewList()
    },

    /**
     * On item per page (entries) changed
     */
    onitemsPerPageChange() {
      this.initializeInvoiceList(false)
    },

    // End pagination methods

    /**
     * Set the color for the background
     * @param {object} invoice
     */
    setBackgroundColor(invoice) {
      var title = ""
      var bg = "white"

      if (invoice.status == constant.STATUS.INVOICE.PAID) {
        bg = "green lighten-5"
        title = "Paid"
      } else if (invoice.overdue) {
        bg = "error lighten-5"
        title = "Overdue"
      } else {
        bg = "white"
        title = null
      }
      return { bg: bg, title: title }
    },

    /**
     * Load companies
     */
    loadCompanies() {
      if (this.$root.is_admin) {
        this.$https
          .get("/api/company/list")
          .then((response) => {
            this.companies = response.data.data
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(() => {
            // this.$root.blockUIshow = false;
          })
      }
    },

    /**
     * Refreash the Invoice View list based on the display page number
     */
    refreshInvoicesViewList() {
      this.invoicesTableView = this.invoices.slice(
        (this.pagination.page - 1) * this.pagination.itemsPerPage,
        this.pagination.page * this.pagination.itemsPerPage
      )
      // console.log("invoicesTableView: ", this.invoicesTableView);
    },

    /**
     *  Call to query for Invoices
     */
    initializeInvoiceList(isAppend) {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Loading invoices..."

      let requestString =
        "/api/invoices/list?limit=" + this.pagination.itemsPerPage

      // let requestString = "/api/invoices/list?limit=3";

      switch (this.filterInvoiceStatus) {
        // Draft
        case 1:
          requestString =
            requestString + `&status=${constant.STATUS.INVOICE.DRAFT}`
          break
        // Submitted
        case 2:
          requestString =
            requestString + `&status=${constant.STATUS.INVOICE.SUBMITTED}`
          break
        // Auhtorised
        case 3:
          requestString =
            requestString + `&status=${constant.STATUS.INVOICE.AUTHORISED}`
          break
        // Paid
        case 4:
          requestString =
            requestString + `&status=${constant.STATUS.INVOICE.PAID}`
          break
        // Trash
        case 5:
          requestString = requestString + `&trash=true`
          break
        default:
          break
      }

      // Only admin can filter by company id
      if (this.$root.is_admin && this.selectedCompany != null) {
        requestString =
          requestString + `&company_id=${this.selectedCompany.company_id}`
      }

      // if next page is requested
      if (isAppend && this.pagination.next_cursor != null) {
        requestString = requestString + "&cursor=" + this.pagination.next_cursor
      } else {
        this.invoices = []
        this.pagination.totalItems = 0
        this.pagination.next_cursor = null
        this.pagination.page = 1
      }

      this.$https
        .get(requestString)
        .then((resp) => {
          var response = resp.data
          if (response.status == constant.RESPONSE_STATUS_OK) {
            // console.log("Invoice: ", response.data);

            this.empty_invoice_list = false

            // push new array of object
            this.invoices.push(...response.data.data)
            if (response.data.count > 0) {
              this.pagination.totalItems = response.data.count
            }
            this.pagination.next_cursor = response.data.next_cursor

            // refresh the invoice view list
            this.refreshInvoicesViewList()
          } else if (response.status == constant.RESPONSE_STATUS_EMPTY) {
            this.empty_invoice_list = true
          } else {
            console.log("Error loading invoice list", response)
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = response.msg
          }
          this.$root.blockUIshow = false

          if (this.$root.is_xero_connected && this.$root.is_super_admin) {
            this.showSnackbar = true
            this.snackbarColor = "success"
            this.snackbarMsg = "Successfully connected to xero"
          } else if (
            !this.$root.is_xero_connected &&
            this.$root.is_super_admin
          ) {
            this.showSnackbar = true
            this.snackbarColor = "warning"
            this.snackbarMsg = "Xero is not unauthenticated"
          }
        })
        .catch((err) => {
          console.log(err)
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = err
          this.$root.blockUIshow = false
        })
    },

    /**
     * Invoice status
     */
    getInvoiceStatus: function (invoice) {
      var color = "black"
      var msg = "Draft Invoice, waiting to be submitted"
      var title = "Draft"

      switch (invoice.status) {
        case constant.STATUS.INVOICE.DRAFT:
          break
        case constant.STATUS.INVOICE.SUBMITTED:
          color = "grey darken-3"
          title = "Awaiting Approval"
          msg = "This invoice has been submitted. Awaiting approval."
          break
        case constant.STATUS.INVOICE.AUTHORISED:
          color = "amber darken-4"
          title = "Awaiting Payment"
          msg = "This invoice has been authorised. Awaiting payment."
          break
        case constant.STATUS.INVOICE.PAID:
          color = "green darken-2"
          title = "Paid"
          msg = "This is a paid invoice."
          break
        case constant.STATUS.INVOICE.DELETED:
          color = "error"
          title = "Deleted"
          msg = "This is a deleted invoice."
          break
        case constant.STATUS.INVOICE.VOIDED:
          color = "error darken-2"
          title = "Voided"
          msg = "This is a voided invoice."
          break
        default:
          break
      }

      return { color: color, title: title, msg: msg }
    },

    async onManageQuotation(quotation) {
      this.$root.blockUImsg = "Loading quotation information"
      this.$root.blockUIshow = true
      // verify user token
      await this.$root.verify_user_token()
      var response = null

      this.$https
        .get("/api/quotations/" + quotation.quotation_id)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.selectedQuotation = response.data
            this.dialogManageQuotation = true
          } else {
            console.log("OnManageQuotation Error: ", response)
          }

          this.$root.blockUIshow = false
        })
    },

    /**
     * Re sync invoice with xero
     */
    onReSyncWithXero(invoice) {
      //! deprecated
      // this.$root.blockUImsg = "Re-Syncing Invoice with Xero"
      // this.$root.blockUIshow = true
      // var response = null
      // this.$https
      //   .put(`/api/invoices/xero/re_sync/${invoice.invoice_id}`)
      //   .then((resp) => (response = resp.data))
      //   .catch((err) => {
      //     console.log(err)
      //   })
      //   .finally(() => {
      //     if (response.status == constant.RESPONSE_STATUS_OK) {
      //       // clone the selected invoice
      //       this.selectedInvoiceSync = invoice
      //       // sync the updated invoice
      //       this.selectedInvoiceSync = Object.assign(
      //         this.selectedInvoiceSync,
      //         response.data
      //       )
      //       this.showSnackbar = true
      //       this.snackbarColor = "success"
      //       this.snackbarMsg = response.msg
      //     } else {
      //       console.log("Error: ", response)
      //       this.showSnackbar = true
      //       this.snackbarColor = "error"
      //       this.snackbarMsg = response.msg
      //     }
      //     this.$root.blockUIshow = false
      //   })
    },

    /**
     * Download Invoice
     */
    downloadInvoice(invoice) {
      this.$root.blockUImsg = "Checking Xero authentication..."
      this.$root.blockUIshow = true

      if (
        !this.$root.has_xero_access_token &&
        this.$root.has_xero_refresh_token
      ) {
        // refresh access token
        this.$root.xero_refresh_access_token()
      } else if (
        !this.$root.has_xero_access_token &&
        !this.$root.has_xero_refresh_token
      ) {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg =
          "Xero access token has expired. Reauthenticate your Xero access"
        this.$root.blockUIshow = false
        return
      }

      this.$root.blockUImsg = "Downloading Invoice..."

      this.$https
        .get(
          `/api/invoices/${invoice.invoice_id}/download_pdf?xero_access_token=${this.$root.xero_access_token}`
        )
        .then((resp) => {
          var response = resp.data
          // console.log("response: ", response)
          if (response.status == constant.RESPONSE_STATUS_OK) {
            const url = window.URL.createObjectURL(new Blob([resp.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", `${invoice.invoice_id}.pdf`)
            document.body.appendChild(link)
            link.click()
            link.remove()
            this.showSnackbar = true
            this.snackbarColor = "success"
            this.snackbarMsg = `Invoice ${invoice.invoice_id} successfully downloaded`
            this.$root.blockUIshow = false
          } else {
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = response.msg
            this.$root.blockUIshow = false
          }
        })
        .catch((err) => {
          console.log("err: ", err)
          console.log(err.request)
          console.log(err.response)
          this.$root.blockUIshow = false
        })
      this.$root.blockUIshow = false
    },

    /**
     * open quotation overview
     */
    onQuotationOverview(invoice) {
      let routeData = this.$router.resolve({
        name: "quotationoverview",
        params: { id: invoice.quotation_id },
      })
      window.open(routeData.href + "?id=" + invoice.quotation_id, "_blank")
    },

    /**
     * manage invoice
     */
    async onManageInvoice(invoice) {
      // this.$root.blockUImsg = "Loading invoice information"
      // this.$root.blockUIshow = true
      // // verify user token
      // await this.$root.verify_user_token()
      // var response = null
      // this.$https
      //   .get(`/api/invoices/${invoice.invoice_id}`)
      //   .then((resp) => (response = resp.data))
      //   .catch((err) => {
      //     console.log(err)
      //   })
      //   .finally(() => {
      //     if (response.status == constant.RESPONSE_STATUS_OK) {
      //       // clone the selected invoice
      //       this.selectedInvoiceSync = invoice
      //       this.selectedInvoice = response.data
      //       this.dialogManageInvoice = true
      //     } else {
      //       console.log("OnManageInvoice Error: ", response)
      //     }
      //     this.$root.blockUIshow = false
      //   })
    },

    /**
     * on open shipment file cabinet
     */
    onOpenShipmentFileCabinet(invoice) {
      this.selectedShipmentId = invoice.quotation_id
      this.selectedCompanyId = invoice.company_id
      this.dialogFileCabinet = true
    },

    /**
     * On close Dialog Manage Quotation
     */
    onDialogManageQuotationClose(
      quotation,
      hasChange,
      isReAssigned = false,
      newCompany = null
    ) {
      this.dialogManageQuotation = false
      this.selectedInvoice = null
    },

    /**
     * On close the dialog
     */
    onDialogClose(dialogID, incomingObj, hasChange) {
      switch (dialogID) {
        case constant.DIALOG_QUOTATION_OVERVIEW:
          this.dialogQuotationOverview = false
          this.selectedQuotationOverview = null
          break

        case constant.DIALOG_MANAGE_INVOICE:
          this.dialogManageInvoice = false

          // sync only if hasChange is true
          if (hasChange) {
            // sync the updated invoice
            this.selectedInvoiceSync = Object.assign(
              this.selectedInvoiceSync,
              incomingObj
            )
          }
          break

        case constant.DIALOG_FILE_CABINET:
          this.dialogFileCabinet = false
          break
      }

      this.selectedInvoice = null
      this.selectedShipmentId = null
      this.selectedCompanyId = null
    },

    /**
     * On update invoice status
     */
    onUpdateInvoiceStatus(invoice, status) {
      // clone invoice
      this.selectedInvoiceSync = invoice
      this.selectedInvoice = invoice
      this.selectedInvoiceStatus = status
      switch (status) {
        case constant.STATUS.INVOICE.SUBMITTED:
          this.updateStatusTitle = "Submit Invoice"
          this.updateStatusMsg = "Are you sure you want to Submit Invoice "
          this.updateStatusBtnName = "SUBMIT"
          break

        case constant.STATUS.INVOICE.AUTHORISED:
          this.updateStatusTitle = "Approve Invoice"
          this.updateStatusMsg = "Are you sure you want to Approve Invoice "
          this.updateStatusBtnName = "APPROVE"
          break
        case constant.STATUS.INVOICE.DELETED:
          this.updateStatusTitle = "Delete Invoice"
          this.updateStatusMsg = "Are you sure you want to Delete Invoice "
          this.updateStatusBtnName = "DELETE"
          break

        // void an authorised invoice
        case constant.STATUS.INVOICE.VOIDED:
          this.updateStatusTitle = "Void Approved Invoice"
          this.updateStatusMsg = "Are you sure you want to Void Invoice "
          this.updateStatusBtnName = "VOID"
          break

        default:
          break
      }

      // open dialog
      this.dialogOnUpdateStatus = true
    },

    /**
     * update invoice status
     */
    updateInvoiceStatus() {
      // this.$root.blockUImsg = "Updating invoice status..."
      // this.$root.blockUIshow = true
      // // validate the selected invoice status
      // if (this.selectedInvoiceStatus == null) {
      //   this.showSnackbar = true
      //   this.snackbarColor = "error"
      //   this.snackbarMsg = "Invalid invoice status"
      //   this.$root.blockUIshow = false
      //   return
      // }
      // this.$https
      //   .put(
      //     `/api/invoices/${this.selectedInvoice.invoice_id}/status/${this.selectedInvoiceStatus}`
      //   )
      //   .then((resp) => {
      //     if (resp.data.status == constant.RESPONSE_STATUS_OK) {
      //       this.dialogOnUpdateStatus = false
      //       // update the invoice
      //       this.selectedInvoiceSync.status = this.selectedInvoiceStatus
      //       // if void or deleted then trash
      //       if (
      //         this.selectedInvoiceStatus == constant.STATUS.INVOICE.DELETED ||
      //         this.selectedInvoiceStatus == constant.STATUS.INVOICE.VOIDED
      //       ) {
      //         this.selectedInvoiceSync.trash = true
      //       }
      //       this.selectedInvoice = null
      //       this.updateStatusTitle = null
      //       this.updateStatusMsg = null
      //       this.updateStatusBtnName = null
      //       this.showSnackbar = true
      //       this.snackbarColor = "success"
      //       this.snackbarMsg = resp.data.msg
      //     } else {
      //       console.log(resp.data)
      //       this.showSnackbar = true
      //       this.snackbarColor = "error"
      //       this.snackbarMsg = resp.data.msg
      //     }
      //     this.$root.blockUIshow = false
      //   })
      //   .catch((err) => {
      //     console.log(err)
      //     this.showSnackbar = true
      //     this.snackbarColor = "error"
      //     this.snackbarMsg = err
      //     this.$root.blockUIshow = false
      //   })
    },
  },

  computed: {
    sortedCompanies: function () {
      return this.companies.sort(function (a, b) {
        return a.name.localeCompare(b.name)
      })
    },
  },
}
</script>

<style></style>
